import { render } from "./AdminWrapper.vue?vue&type=template&id=19847632"
import script from "./AdminWrapper.vue?vue&type=script&lang=ts"
export * from "./AdminWrapper.vue?vue&type=script&lang=ts"

import "./AdminWrapper.vue?vue&type=style&index=0&id=19847632&lang=stylus"
script.render = render

export default script